import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
  Card,
  Typography,
  IconButton,
  Icon
} from '@material-ui/core';
import {deleteHelpCategoryApi} from 'api/help';


const MainTabsList = ({setCategory}) => {
  const dispatch = useDispatch();
  const { helpCategories } = useSelector((state) => state.help);

  return (
    <div>
      <Typography variant="h4" className="text-brand ml-4 mt-8">Main Categories List</Typography>
      {helpCategories.map((element) => (
        <Card
          className="p-4 m-4 flex justify-between items-center"
          key={element._id}
        >
          <Typography variant="h6" className="text-brand">{element.title}</Typography>
          <div>
            <IconButton
              className="mr-2"
              title="Edit"
              onClick={() => setCategory(element)}
            >
              <Icon className="text-gray">edit</Icon>
            </IconButton>
            <IconButton
              className="mr-2"
              title="Delete"
              onClick={() => deleteHelpCategoryApi({dispatch, categoryId: element._id})}
            >
              <Icon className="text-gray">delete</Icon>
            </IconButton>
          </div>

        </Card>
      ))}
    </div>
  );
};

export default MainTabsList;
